import { IRiskAppBand } from '../types';
import { EntityService } from './EntityService';

export class RiskAppBandService extends EntityService<IRiskAppBand> {
    private apiURL: string;
    constructor() {
        super(`/RiskAppBands`);
        const apiURL = process.env.REACT_APP_ZedX_API!;
        this.apiURL = apiURL;
    }

    public async updateHeatMapConfig(payload: {
        RiskAppBandID: number;
        RiskScoreFormulaID: number;
    }): Promise<void> {

        await this.axiosPost(
            `${this.apiURL}/UpdateHeatMapConfig`,
            payload
        );
    }
}